function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect, useRef } from 'react';
export var useThemeModeImage = function useThemeModeImage(defaultSrc, themeModeSrc) {
  var _useState = useState(defaultSrc),
    _useState2 = _slicedToArray(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  useEffect(function () {
    var isCancelled = false;
    var img = new Image();
    img.src = themeModeSrc;
    if (img.complete && !isCancelled) {
      setSrc(themeModeSrc);
    } else if (!isCancelled) {
      setSrc(themeModeSrc);
    }
    img.onload = function () {
      if (!isCancelled) {
        setSrc(themeModeSrc);
      }
    };
    return function () {
      isCancelled = true;
    };
  }, [defaultSrc, themeModeSrc]);
  return [src];
};
export var useProgressiveImg = function useProgressiveImg(lowQualitySrc, highQualitySrc) {
  var _useState3 = useState(lowQualitySrc || highQualitySrc),
    _useState4 = _slicedToArray(_useState3, 2),
    src = _useState4[0],
    setSrc = _useState4[1];
  useEffect(function () {
    var img = new Image();
    img.src = highQualitySrc;
    if (img.complete) {
      setSrc(highQualitySrc);
    } else {
      setSrc(lowQualitySrc);
    }
    img.onload = function () {
      setSrc(highQualitySrc);
    };
  }, [lowQualitySrc, highQualitySrc]);
  return [src, {
    blur: src === lowQualitySrc
  }];
};

/**
 * Helps determine whether or not an element is currently focused.
 *
 * @param {Boolean} initialFocus: defaults to `false`. Whether or not the element should have default focus.
 * @returns An array containing: a `ref` to associate with the element, boolean `isFocused` representing if
 * the element is currently focused, function `setIsFocused(value: Boolean) => void` set current value of `isFocused`.
 */
export function useIsFocused() {
  var initialFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState5 = useState(initialFocus),
    _useState6 = _slicedToArray(_useState5, 2),
    isFocused = _useState6[0],
    setIsFocused = _useState6[1];
  var ref = useRef(null);
  var handleClickOutside = function handleClickOutside(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      setIsFocused(false);
    }
  };
  var handleKeypress = function handleKeypress(e) {
    if (e.key === 'Escape') {
      setIsFocused(false);
    }
  };
  useEffect(function () {
    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('keydown', handleKeypress, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('keydown', handleKeypress, true);
    };
  }, []);
  return [ref, isFocused, setIsFocused];
}